<div class="event-subscription-manager">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold">Ereignisbenachrichtigungen</h3>
        <div class="flex gap-2">
            <button class="btn btn-sm btn-outline" (click)="subscribeToAll()" [disabled]="loading">
                <i class="fa-solid fa-bell"></i> Alle abonnieren
            </button>
            <button class="btn btn-sm btn-outline" (click)="unsubscribeFromAll()" [disabled]="loading">
                <i class="fa-solid fa-bell-slash"></i> Alle abbestellen
            </button>
        </div>
    </div>

    <!-- Error/Success Messages -->
    <div *ngIf="error" class="p-3 mb-4 bg-red-100 text-red-700 rounded-md">
        <i class="fa-solid fa-circle-exclamation mr-2"></i>{{error}}
        <button class="float-right" (click)="clearMessages()">
            <i class="fa-solid fa-times"></i>
        </button>
    </div>
    <div *ngIf="successMessage" class="p-3 mb-4 bg-green-100 text-green-700 rounded-md">
        <i class="fa-solid fa-check-circle mr-2"></i>{{successMessage}}
        <button class="float-right" (click)="clearMessages()">
            <i class="fa-solid fa-times"></i>
        </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex justify-center py-8">
        <i class="fa-solid fa-spinner fa-spin text-2xl text-gray-500"></i>
    </div>

    <!-- Current Subscriptions -->
    <div class="mb-6" *ngIf="!loading">
        <h4 class="font-medium mb-3">Aktive Abonnements</h4>
        <div *ngIf="subscriptions.length === 0" class="text-gray-500 p-4 bg-gray-50 rounded-md">
            <i class="fa-solid fa-bell-slash mr-2"></i>
            Keine Ereignisabonnements vorhanden. Fügen Sie Abonnements hinzu, um Benachrichtigungen zu erhalten.
        </div>
        <div *ngFor="let sub of subscriptions" class="p-3 border rounded-md mb-2 flex justify-between items-center">
            <div>
                <span class="font-medium">{{getEventTypeLabel(sub.eventType)}}</span>
                <span class="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">
                    {{getDeliveryChannelLabel(sub.deliveryChannel)}}
                </span>
                <div class="text-xs text-gray-500 mt-1">
                    Abonniert: {{sub.subscribedAt | date:'short'}}
                    <span *ngIf="sub.lastDeliveredAt" class="ml-2">
                        | Letzte Benachrichtigung: {{sub.lastDeliveredAt | date:'short'}}
                    </span>
                </div>
            </div>
            <button class="btn btn-sm btn-outline text-red-600" (click)="deactivateSubscription(sub.id)">
                <i class="fa-solid fa-trash"></i>
            </button>
        </div>
    </div>

    <!-- Add Subscription -->
    <div class="border-t pt-4" *ngIf="!loading">
        <h4 class="font-medium mb-3">Abonnement hinzufügen</h4>
        <div class="grid grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium mb-1">Ereignistyp</label>
                <select [(ngModel)]="selectedEventType" class="form-select w-full">
                    <option [ngValue]="null">-- Ereignistyp auswählen --</option>
                    <option *ngFor="let opt of eventTypeOptions" [ngValue]="opt.value">
                        {{opt.label}}
                    </option>
                </select>
            </div>
            <div>
                <label class="block text-sm font-medium mb-1">Zustellkanal</label>
                <select [(ngModel)]="deliveryChannel" class="form-select w-full">
                    <option *ngFor="let opt of deliveryChannelOptions" [value]="opt.value">
                        {{opt.label}}
                    </option>
                </select>
            </div>
        </div>
        <button class="btn btn-primary mt-4" [disabled]="selectedEventType === null" (click)="createSubscription()">
            <i class="fa-solid fa-plus"></i> Abonnement hinzufügen
        </button>
    </div>
</div>
